/* src/app/components/footer/footer.component.scss */
footer {
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
  z-index: 9000;
  background: #1e1f20;
  padding: 0 1rem;
  margin-bottom: 0;
  color: #dee2e6;
  font-size: 0.7rem;
  min-height: 1.5rem;
}
footer.pag-inicial {
  font-size: 0.8rem;
  padding: 1rem 1rem;
  min-height: 3rem;
}
footer.pag-inicial .footer-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.footer-main {
  z-index: 90000;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1024px;
}
.container div {
  vertical-align: middle;
}
.footer-text {
  vertical-align: middle;
}
.footer-icons {
  padding: 0;
  vertical-align: top;
  display: none;
  text-align: center;
}
.footer-icons.pag-inicial {
  display: block;
}
.footer-version {
  padding: 0;
  color: #adb5bd;
  line-height: 2.1rem;
}
.footer-version.pag-inicial {
  display: none;
}
.ratings {
  display: none;
  text-align: center;
}
.ratings.pag-inicial {
  display: block;
}
.classif-logo {
  width: 35px;
  height: 35px;
  border-width: 0;
  margin-right: 0.7rem;
}
.cc-logo {
  width: 88px;
  height: 31px;
  border-width: 0;
  margin-left: 0.7rem;
}
ul.c-footer-icons {
  color: #fff;
  font-size: 0;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}
.c-footer-icons li {
  display: inline-block;
  text-align: -webkit-match-parent;
  margin: 0 0.2rem;
}
.c-footer-icons a {
  display: block;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  padding: 12px;
  transition: 150ms ease;
  width: 40px;
  will-change: box-shadow;
}
.c-footer-icons a:hover {
  box-shadow: inset 0 0 0 22px #673ab7;
}
.c-footer-icons svg {
  fill: #fff;
  height: 16px;
  width: 16px;
}
a.privacy {
  color: #adb5bd;
}
a.privacy:hover,
a.privacy:focus,
a.privacy:active {
  color: white;
}
.social-small {
  transform: scale(0.65);
}
@media (max-width: 500px) {
  footer.pag-inicial {
    padding: 1rem 0.2rem;
  }
  .container {
    padding: 0 0.1rem;
  }
  .footer-icons {
    display: none;
  }
  .sr-footer-icons {
    transform: scale(0.65);
    margin: 0;
  }
  .classif-logo {
    margin: 0.2rem;
  }
  .cc-logo {
    margin: 0.2rem;
  }
}
/*# sourceMappingURL=footer.component-MIWFJSFZ.css.map */
